export default "__VITE_ASSET__hld9DTql__"